import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/begin-year/:key?',
    name: 'beginYearEstimate',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/estimate/beginYearEstimate/BeginYearEstimate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.Ward, i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
  {
    path: '/three-year',
    name: 'threeYearEstimate',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/estimate/threeYearEstimate/ThreeYearEstimate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.Ward, i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
  {
    path: '/estimate-initial/:key?',
    name: 'EstimateInitial',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/estimate/estInitial/EstimateInitial.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.Ward, i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
];
